import React from "react";

/**
 * Barra inferior fija. Siempre visible.
 * `estadoGlobal`: "saved" | "saving" | "error" | "idle"
 * `finalizacion`: { puedeFinalizar, bloqueos:[{titulo}], avisos:[...] }
 */
export default function BarraInferior({
  estadoGlobal,
  ultimoGuardado,
  finalizacion,
  hayPendientesNav,
  onIrAloQueFalta,
  onGuardarSalir,
  onFinalizar,
  finalizarDisponible = true,
}) {
  const { puedeFinalizar, bloqueos } = finalizacion;
  const nBloqueos = bloqueos.length;

  let statusNode;
  if (estadoGlobal === "saving")
    statusNode = <span className="cev__bottom-status cev__bottom-status--saving">Guardando cambios…</span>;
  else if (estadoGlobal === "error")
    statusNode = (
      <span className="cev__bottom-status cev__bottom-status--error" role="alert">
        ⚠ Hay cambios sin guardar
      </span>
    );
  else
    statusNode = (
      <span className="cev__bottom-status cev__bottom-status--saved" aria-live="polite">
        ✓ Todos los cambios guardados
        {ultimoGuardado ? ` · ${ultimoGuardado.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}` : ""}
      </span>
    );

  const tituloFinalizar = puedeFinalizar
    ? undefined
    : `Falta completar: ${bloqueos.map((b) => b.titulo).join(", ")}`;

  return (
    <div className="cev__bottom" role="region" aria-label="Acciones de la consulta">
      {statusNode}

      {nBloqueos > 0 && (
        <span className="cev__bottom-warn">
          ⚠ {nBloqueos === 1 ? "Falta 1 sección obligatoria" : `Faltan ${nBloqueos} secciones obligatorias`}
        </span>
      )}

      <div className="cev__bottom-grow" />

      {hayPendientesNav && (
        <button type="button" className="cev__btn cev__btn--sm" onClick={onIrAloQueFalta}>
          Ir a lo que falta
        </button>
      )}

      <button type="button" className="cev__btn" onClick={onGuardarSalir}>
        Guardar y salir
      </button>

      <button
        type="button"
        className="cev__btn cev__btn--pri"
        onClick={onFinalizar}
        disabled={!puedeFinalizar || !finalizarDisponible}
        title={tituloFinalizar}
        aria-describedby={!puedeFinalizar ? "cev-finalizar-motivo" : undefined}
      >
        Finalizar atención
      </button>
      {!puedeFinalizar && (
        <span id="cev-finalizar-motivo" hidden>
          {tituloFinalizar}
        </span>
      )}
    </div>
  );
}
